<template>
  <img
    :src="airplaneIcon"
    alt=""
    class="zone-airport-icon"
  />
</template>

<script>
import airplaneIcon from '../../assets/images/airplane_filled.svg'

export default {
  name: 'AirportZoneIcon',

  data() {
    return {
      airplaneIcon,
    }
  },
}
</script>

<style>

.zone-airport-icon {
  width: 0.8em;
  height: 0.8em;
  vertical-align: 0;
  display: inline-block;
  opacity: 1;
  margin-left: -15px;
  position: absolute;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
}
.vs__dropdown-option {
  position: relative;
}
</style>
